import React, { Component } from 'react';
import cx from 'classnames';
import { injectIntl } from 'react-intl';

import TranslatedCopy from '../../../../intl/translated-copy';
import { getUserInitials } from '../utils/amaia-helpers';
import Pictogram from '../../pictogram';
import { sanitizeAndRenderMarkdown } from '../../../../utilities/message-utils';

const SENDER_USER = 'user';

class MessageBubble extends Component {
  shouldComponentUpdate(nextProps) {
    return (
      nextProps.msg.text !== this.props.msg.text ||
      nextProps.isSignedIn !== this.props.isSignedIn ||
      nextProps.userFirstName !== this.props.userFirstName
    );
  }

  render() {
    const { msg } = this.props;

    if (msg.sender === SENDER_USER) {
      return this.renderUserBubble();
    }

    return this.renderAmaiaBubble();
  }

  renderUserAvatar() {
    const { isSignedIn, userFirstName } = this.props;

    const avatarClasses = cx('bubble-avatar-user', {
      'is-default': !isSignedIn,
      'is-signed-in': isSignedIn,
    });

    return (
      <div className={avatarClasses}>
        {isSignedIn ? (
          <span>{getUserInitials(userFirstName)}</span>
        ) : (
          <Pictogram id='AmaiaUserDefault' />
        )}
      </div>
    );
  }

  renderUserBubble() {
    const { msg } = this.props;

    return (
      <div className='bubble--user'>
        <div className='bubble-text'>{msg.text}</div>
        <div className='bubble-meta'>
          <span className='bubble-time'>{msg.time}</span>
          {this.renderUserAvatar()}
        </div>
      </div>
    );
  }

  renderAmaiaBubble() {
    const {
      intl,
      msg,
    } = this.props;
    
    return (
      <div className='bubble--amaia'>
        <Pictogram className='bubble-avatar-amaia' id='AmaiaAvatarStatic' />
        {msg.copyId ? (
          <div className='bubble-text'>
            <TranslatedCopy copyID={msg.copyId} />
          </div>
        ) : (
          <div
            className='bubble-text'
            dangerouslySetInnerHTML={{
              __html: sanitizeAndRenderMarkdown(msg.text || '', intl),
            }}
          />
        )}
      </div>
    );
  }
}

export default injectIntl(MessageBubble);
